export default "__VITE_ASSET__Z72FskwO__"